import { Injectable } from "@angular/core";
import {
    ActivatedRouteSnapshot,
    Router,
    RouterStateSnapshot,
} from "@angular/router";
import { UtilitiesService } from "../services/utilities.service";

@Injectable({ providedIn: "root" })
export class DesktopGuard {
    constructor(
        private readonly _router: Router,
        private readonly _utilitiesService: UtilitiesService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this._utilitiesService.isMobile()) {
            return this._router.createUrlTree(["/desktop"]);
        } else {
            return true;
        }
    }
}
